import { CreateWorkspaceFormData as Request } from '@aibees/shared/components';
import { Workspace } from '@aibees/shared/definition';
import { useBaseMutation } from '@aibees/shared/http/hooks';

export function useCreateWorkspaceMutationApi() {
  // TODO change to url used before url: `/${API_BASE_PATH}/um/workspaces`,
  return useBaseMutation<Request, Workspace>({
    url: `/customer-management/um/workspaces`,
  });
}
